import { gql } from '@apollo/client';

export const BENEFIT_PAYLOAD = gql`
    fragment BenefitFragment on Benefit {
        _id
        name
    }
`;

export const getBenefitsQuery = gql`
    query getBenefits {
        benefits: getBenefits {
            ...BenefitFragment
        }
    }
    ${BENEFIT_PAYLOAD}
`;

export const ADD_BENEFIT_PRO = gql`
  mutation addBenefitPro($name: String!, $order: Int) {
    data: addBenefitPro(name: $name, order: $order) {
      _id
      name
      category
      status
      order
    }
  }
`;

export const DELETE_BENEFIT_PRO = gql`
  mutation deleteBenefitPro($id: ID!) {
    deleteBenefitPro(id: $id)
  }
`;
